import { Box, Typography } from "@material-ui/core";
import clsx from "clsx";
import React, { useState } from "react";
import Calendar from "react-calendar";
import PrimaryButton from "../../Components/UI/Buttons/PrimaryButton";
import LightButton from "../../Components/UI/Buttons/LightButton";
import flexStyles from "../../style/flex";
import textStyle from "../../style/typography";
import EmailComponent from "./EmailComponent";
import { useStyles } from "./style";

const timeSlots = [
  `1:00 PM - 2:00 PM`,
  `2:00 PM - 3:00 PM`,
  `4:00 PM - 5:00 PM`,
];

const DemoComponent = ({ setStep }) => {
  const classes = useStyles();

  return (
    <Box className={classes.demoCard}>
      <Box className={classes.demoCardHeader}>
        <Box style={{ marginTop: 18 }}>
          <PrimaryButton hideIcon={true} onClick={() => setStep(2)}>
            Book a demo
          </PrimaryButton>
        </Box>
      </Box>
    </Box>
  );
};

const FormComponent = ({ setStep, date, onDateChange, slot, setSlot }) => {
  const flexClasses = flexStyles();
  const classes = useStyles();
  const textClasses = textStyle();

  const tileDisabled = ({ activeStartDate, dateToCheck, view }) => {
    return dateToCheck <= new Date();
  };

  return (
    <Box className={classes.formWrap}>
      <Box className={classes.backContainer}>
        <LightButton onClick={() => setStep(1)}>Back</LightButton>
      </Box>
      <Box className={flexClasses.flexContainer}>
        <Box className={flexClasses.itemMD}>
          <Typography className={textClasses.header2}>Select Date</Typography>
          <Calendar
            onChange={onDateChange}
            value={date}
            className={classes.calendar}
            minDate={new Date(Date.now() + 86400000)}
          />
        </Box>
        <Box className={flexClasses.itemMD}>
          <Typography className={textClasses.header2}>Select Timing</Typography>
          <Box className={classes.slotWrap}>
            {timeSlots.map((ele, slotIndex) => (
              <Box
                className={clsx(classes.slotCard, {
                  [classes.selected]: ele === slot,
                })}
                key={slotIndex}
                onClick={() => setSlot(ele)}
              >
                <Typography>{ele}</Typography>
              </Box>
            ))}
          </Box>

          <Box className={classes.formActions}>
            <PrimaryButton hideIcon={true} onClick={() => setStep(3)}>
              Continue
            </PrimaryButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const Form = ({ component }) => {
  const textClasses = textStyle();

  const [step, setStep] = useState(1);

  const [date, onDateChange] = useState(new Date(Date.now() + 86400000));
  const [slot, setSlot] = useState(`1:00 PM - 2:00 PM`);

  const config = {
    1: <DemoComponent setStep={setStep} />,
    2: (
      <FormComponent
        setStep={setStep}
        date={date}
        onDateChange={onDateChange}
        slot={slot}
        setSlot={setSlot}
      />
    ),
    3: (
      <EmailComponent
        date={date}
        slot={slot}
        setStep={setStep}
        onDateChange={onDateChange}
        setSlot={setSlot}
      />
    ),
  };

  return (
    <Box>
      <Box style={{ paddingTop: 18 }}>
        <Typography className={textClasses.header2}>
          Schedule a demo with to
        </Typography>
        <Typography className={textClasses.header1}>
          Learn How We Can Revolutionize Your Care Agency
        </Typography>
      </Box>
      {config[step]}
    </Box>
  );
};

export default Form;
